// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3f1fb51b","885":"fb3e19aa"}[chunkId] + ".chunk.js";
};